// Types
import { SignatureData } from '../../types/signatureData';
import apiClient from './apiClient';

export const getSignature = async (slotId: string, userId: string): Promise<SignatureData | null> => {
    try {
        const response = await apiClient.get('/signatures', {
            params: { slotId, userId }
        });
        const data = response.data.data[0];
        return data
            ? {
                  id: data.id,
                  signature: data.signature,
                  isPresent: data.isPresent,
                  date: data.date
              }
            : null;
    } catch (error) {
        console.error('Error getting signature:', error);
        return null;
    }
};

export const postSignature = async (slotId: string, userId: string, signature: string | null, isPresent: boolean): Promise<void> => {
    try {
        await apiClient.post('/signatures', {
            slotId,
            userId,
            signature,
            isPresent
        });
    } catch (error) {
        console.error('Error posting signature:', error);
    }
};

export const putSignature = async (signatureId: string, signature: string | null, isPresent: boolean): Promise<void> => {
    try {
        await apiClient.put(`/signatures/${signatureId}`, {
            signature,
            isPresent
        });
    } catch (error) {
        console.error('Error putting signature:', error);
    }
};

export const deleteSignature = async (signatureId: string): Promise<void> => {
    try {
        await apiClient.delete(`/signatures/${signatureId}`);
    } catch (error) {
        console.error('Error deleting signature:', error);
    }
};
